export default {
  'intl-locale': 'pt-BR',
  system: {
    loading: 'Carregando...',
    error: {
      title: 'Falha no Sistema',
      message: 'Desculpe, houve uma falha no sistema. Tente novamente.'
    }
  },
  filter: {
    select: 'Selecione',
    'btn-submit-text': 'Filtrar',
    'btn-clear-text': 'Limpar',
    'nav-between-groups': 'Grupo de filtros {{group}}/{{totalGroup}}',
    'complement-or': 'Filtrar - Complementar (OR)',
    'refine-and': 'Filtrar - Refinar (AND)',
    loading: 'Carregando filtro...',
    filters: 'Filtros'
  },
  'filter-composition': {
    'label-field': 'Composição Filtro'
  },
  filteractions: {
    'select-label': 'Filter Actions',
    'initial-selection': 'Filtro inicial zerado'
  },
  pagination: {
    pages: 'Páginas',
    'go-to-page': 'Ir para a página'
  },
  'data-table': {
    selection: 'Seleção',
    actions: 'Ações',
    'no-records-found': 'Nenhum registro encontrado',
    'select-all': 'Selecionar todos',
    'navigate-between-table-columns': 'Navegar entre colunas da tabela',
    previous: 'Anterior',
    next: 'Próximo'
  },
  multifree: {
    item: 'item',
    items: 'itens',
    add: 'adicionar',
    remove: 'remover',
    clear: 'limpar'
  },
  uniselection: {
    clear: 'limpar',
    'show-options': 'mostrar opções',
    'hide-options': 'esconder opções'
  },
  multiselection: {
    clear: 'limpar',
    'show-options': 'mostrar opções',
    'hide-options': 'esconder opções',
    selection: 'seleção',
    selections: 'seleções',
    'option-selected': 'opção selecionada',
    'options-selected': 'opções selecionadas',
    selections_one: '{{count}} seleção',
    selections_multiple: '{{count}} seleções'
  },
  datepicker: {
    select: 'Selecionar'
  },
  'navigation-slider': {
    previous: 'Ir para o anterior',
    next: 'Ir para o próximo',
    beginning: 'Ir para o início',
    last: 'Ir para o último',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha'
  },
  task: {
    model: 'Modelo de Tarefa',
    sid: 'SID da Tarefa',
    'assigned-requester': 'Solicitante Previsto',
    'assigned-executor': 'Executor Previsto',
    'scheduled-submission': 'Submissão Prevista em',
    'scheduled-start': 'Iniciação Prevista em',
    priority: {
      low: 'baixa',
      normal: 'normal',
      high: 'alta',
      urgent: 'urgente'
    },
    action: {
      approve: 'Aprovar',
      cancel: 'Cancelar',
      copy: 'Copiar',
      deliver: 'Entregar',
      lock: 'Travar',
      'mark-as-failed': 'Constar como falhada',
      pause: 'Pausar',
      reject: 'Reprovar',
      restart: 'Reiniciar',
      resume: 'Retomar',
      return: 'Devolver',
      start: 'Iniciar',
      take: 'Assumir',
      unlock: 'Destravar',
      view: 'Visualizar',
      execute: 'Executar'
    }
  },
  'loading-page': {
    heading: 'A página está sendo carregada',
    complement: 'Isto pode levar alguns minutos.\nPor favor, aguarde.'
  },
  'transfer-order-card': {
    shipper: 'Entregador',
    receiver: 'Receptor',
    'delivery-order': 'Ordem de Entrega',
    'receipt-order': 'Ordem de Recebimento',
    'order-table-header': 'Ordem | Descrição | Qtd | Un. de Medida',
    view: 'Visualizar'
  },
  'route-section': {
    'sid-label': 'SID Rota',
    estimated: 'Tempo Estimado e KM Estimada'
  },
  'transport-card': {
    route: 'Rota',
    checkpoints: 'Pontos de Passagem'
  },
  'checkpoint-section': {
    status: {
      todo: 'A Visitar',
      doing: 'Iniciado',
      done: 'Finalizado'
    },
    'map-button': 'Mapa',
    view: 'Visualizar',
    'transfer-order': 'Ordens de Transferência'
  },
  'priority-tag': {
    low: 'baixa',
    normal: 'normal',
    high: 'alta',
    urgent: 'urgente'
  },
  'training-card': {
    duration: 'Tempo de duração',
    seconds: 'segundos',
    minutes: 'minutos',
    'play-video': 'reproduzir vídeo'
  },
  '503-error': {
    title: 'Estamos Temporariamente Indisponíveis',
    'description-1': 'Nossos serviços estão indisponíveis no momento.',
    'description-2':
      'Por favor vá para a página inicial ou tente novamente em alguns instantes.',
    'try-again': 'Tentar novamente',
    'alt-img': 'Erro 503'
  },
  saf: {
    legend: 'Legenda',
    in: 'Entradas',
    out: 'Saídas',
    'initial-stock': 'Estoque inicial',
    'final-stock': 'Estoque final',
    totals: 'Totais'
  },
  'text-fading': {
    'read-more': 'Leia mais',
    'read-less': 'Leia menos'
  },
  accordion: {
    'summary-item': 'Item de resumo',
    'toggle-accordion': 'Alternar acordeão'
  },
  'contact-object-card': {
    'phone-number': 'Número de telefone'
  }
}
